// Predictions slice — parsed per-side prediction `FrameMap`s. Spec §4.2, §5.3, §8.
//
// Side-suffixed field names (`predLeft`/`predRight`) instead of the spec's
// `{ left, right }` because the edits slice also uses `left`/`right` and the
// store is composed as one flat object. See task3_PR1.md "Deviations" note.

import type { StateCreator } from 'zustand';
import type { FrameMap } from '../types';
import type { AppState } from './index';

export type Side = 'front_left' | 'front_right' | 'left' | 'right';

export interface PredictionsSlice {
  predFrontLeft: FrameMap | null;
  predFrontRight: FrameMap | null;
  predLeft: FrameMap | null;
  predRight: FrameMap | null;
  setPredictions: (side: Side, frameMap: FrameMap | null) => void;
}

export const createPredictionsSlice: StateCreator<
  AppState,
  [['zustand/immer', never]],
  [],
  PredictionsSlice
> = (set) => ({
  predFrontLeft: null,
  predFrontRight: null,
  predLeft: null,
  predRight: null,
  setPredictions: (side, frameMap) =>
    set((s) => {
      if (side === 'front_left') s.predFrontLeft = frameMap;
      else if (side === 'front_right') s.predFrontRight = frameMap;
      else if (side === 'left') s.predLeft = frameMap;
      else s.predRight = frameMap;
    }),
});
